import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CTAButton from '../ctaButton/CTAButton';
import List from '../list/List';

const Text = (props) => {
  const componentClasses = classNames('blocks__text-block', {
    [`blocks--${props.colourScheme}`]: props.colourScheme,
    [`titles--${props.titleColour}`]: props.titleColour === 'no-bottom'
  });

  return (
    <section className={componentClasses}>
      <div className="blocks__text-block-text" dangerouslySetInnerHTML={{ __html: props[props.src] || props.text }} />
      {props.callToAction ? <CTAButton {...props.callToAction} /> : null}
    </section>
  );
};

Text.propTypes = {
  callToAction: PropTypes.shape(CTAButton.propTypes)
};

const TextIcon = (props) => {
  const { header } = props;

  return (
    <section className="blocks__text-block blocks__text-block--icon">
      <div className="blocks__text-block-text">
        <div className="block__textIcon__wrapper">
          <div>
            <img className="block__textIcon__icon" src={header.src} alt={header.alt} aria-hidden="true"></img>
          </div>
          <div className="block__textIcon__wrapper-header">
            <h2 className="block__textIcon__title">{header.header}</h2>
            <h3 className="block__textIcon__subtitle">{header.subtitle}</h3>
          </div>
        </div>
        <div
          className="blocks__text-block-text blocks__text-block-text--icon"
          dangerouslySetInnerHTML={{ __html: props[props.src] || props.text }}
        />
      </div>
    </section>
  );
};

TextIcon.propTypes = {
  header: PropTypes.object
};

const Image = ({ src, contain, alt, size, position, className, colourScheme, hideOnDesktop, hideOnMobile }) => {
  const componentClasses = classNames('blocks__image-block', {
    [className]: className,
    [`blocks--${colourScheme}`]: colourScheme,
    'blocks__image-block--contain': contain || size === 'contain',
    'blocks__image-block--proportional': size === 'proportional',
    [`blocks__image-block--position-${position}`]: position,
    'blocks__image-block--hide-on-mobile': hideOnMobile,
    'blocks__image-block--hide-on-desktop': hideOnDesktop
  });

  return (
    <div className={componentClasses}>
      <LazyLoadImage src={src} alt={alt} />
    </div>
  );
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['initial', 'contain', 'full', 'proportional']),
  position: PropTypes.oneOf([null, 'top-centre']),
  className: PropTypes.string,
  colourScheme: PropTypes.oneOf([
    'dark-navy',
    'light-grey',
    'teal',
    'neutral-teal',
    'neutral-navy',
    'pastel-purple',
    'sand'
  ]),
  hideOnMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hideOnDesktop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

const ListBlock = (props) => {
  const componentClasses = classNames('blocks__list-block', {
    [`blocks--${props.colourScheme}`]: props.colourScheme,
    [`blocks--${props.customPadding}`]: props.customPadding,
    [`blocks__list-block--${props.alignment}-align`]: props.alignment
  });

  return (
    <section className={componentClasses}>
      <List {...props} />
    </section>
  );
};

const Custom = ({ colourScheme, children, alignment }) => {
  const componentClasses = classNames('blocks__custom', {
    [`blocks--${colourScheme}`]: colourScheme
  });

  const innerComponentClasses = classNames('blocks__custom-inner', {
    [`blocks__custom-inner--${alignment}-align`]: alignment
  });

  return (
    <div className={componentClasses}>
      <div className={innerComponentClasses}>{children}</div>
    </div>
  );
};

const Blocks = ({ className, children, reverse, sectionId, theme, alignContent, colourScheme }) => {
  const componentClasses = classNames('blocks-section', {
    [className]: className,
    [`blocks-section--theme-${theme}`]: theme,
    'blocks-section--reverse': reverse,
    [`blocks-section--align-content-${alignContent}`]: alignContent,
    [`blocks-section--colour-scheme-${colourScheme}`]: colourScheme
  });

  return (
    <section id={sectionId ? sectionId : null} className={componentClasses}>
      {children}
    </section>
  );
};

Blocks.Text = Text;
Blocks.Image = Image;
Blocks.List = ListBlock;
Blocks.Custom = Custom;
Blocks.TextIcon = TextIcon;

// FIXME another case of bool casting to string
Blocks.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array,
  reverse: PropTypes.string,
  sectionId: PropTypes.string,
  alignContent: PropTypes.oneOf([null, 'centre']),
  colourScheme: PropTypes.oneOf([
    'dark-navy',
    'dark-teal',
    'light-grey',
    'teal',
    'neutral-teal',
    'neutral-navy',
    'pastel-purple',
    'sand',
    'white'
  ])
};

export default Blocks;
